import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Tag = ({ children, className = "" }) => (
  <span className={`inline-block bg-brand/25 text-ink font-bold text-xs uppercase tracking-[0.18em] px-3 py-1.5 rounded-full ${className}`}>
    {children}
  </span>
);
